module.exports = __webpack_public_path__ + "static/media/alyssa_profile_pic.2b755291.jpeg";